"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCancellableRequest = exports.handleCancellableResponse = void 0;
const axios_1 = __importDefault(require("axios"));
const currentExecutingCancellableRequests = {};
const handleCancellableResponse = (token) => {
    if (!token) {
        return;
    }
    const key = Object.keys(currentExecutingCancellableRequests).find((key) => currentExecutingCancellableRequests[key].token === token);
    if (key) {
        delete currentExecutingCancellableRequests[key];
    }
};
exports.handleCancellableResponse = handleCancellableResponse;
const handleCancellableRequest = (request) => {
    const cancelUniqId = request.cancelToken;
    if (currentExecutingCancellableRequests[cancelUniqId]) {
        const source = currentExecutingCancellableRequests[cancelUniqId];
        delete currentExecutingCancellableRequests[cancelUniqId];
        source.cancel("canceled");
    }
    if (cancelUniqId) {
        const CancelToken = axios_1.default.CancelToken;
        const source = CancelToken.source();
        request.cancelToken = source.token;
        currentExecutingCancellableRequests[cancelUniqId] = source;
    }
};
exports.handleCancellableRequest = handleCancellableRequest;
